import { isMobile, getWindowSize } from "@/utils/deviceDetect"
import { Toast } from "vant"
import i18n from "@/locale"

export default {
  namespaced: true,
  state: () => ({
    isOnline: navigator.onLine,
    language: "en",
    isLoading: false,
    error: null,
    isMobile: isMobile(),
    windowSize: getWindowSize()
  }),
  mutations: {
    UPDATE_IS_MOBILE(state, status) {
      state.isMobile = status
    },
    UPDATE_WINDOW_SIZE(state, size) {
      state.windowSize = { ...size }
    },
    SET_NETWORK_STATUS(state, status) {
      state.isOnline = status
    },
    SET_LANGUAGE(state, lang) {
      state.language = lang
      localStorage.setItem("language", lang)
    },
    SET_LOADING(state, loading) {
      state.isLoading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    initWindowListener({ commit }) {
      commit("UPDATE_IS_MOBILE", isMobile())
      commit("UPDATE_WINDOW_SIZE", getWindowSize())
    },
    showLoading({ commit }, message) {
      commit("SET_LOADING", true)
      Toast.loading({
        message: message || i18n.t("index").msg.Loading,
        forbidClick: true,
        duration: 0
      })
    },

    clearLoading({ commit }) {
      Toast.clear()
      commit("SET_LOADING", false)
    },
    setLanguage({ commit }, lang) {
      commit("SET_LANGUAGE", lang)
      i18n.locale = lang
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js